import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { WebApiService } from 'src/app/shared';
import { SubsidySection } from './subsidy-section.model';

@Injectable({
  providedIn: 'root'
})
export class SubsidySectionService extends WebApiService {
  private readonly subsidyUrl = 'cssubsidy';

  constructor(protected http: HttpClient, protected snackBar: MatSnackBar) {
    super(http, snackBar);
  }

  public addSubsidySection(projectId: Guid, newSubsidySection: SubsidySection): Observable<SubsidySection> {
    return this.post(projectId, this.subsidyUrl, newSubsidySection);
  }

  public getSubsidySection(projectId: Guid): Observable<SubsidySection> {
    return this.get(projectId, this.subsidyUrl);
  }

  public updateSubsidySection(projectId: Guid, updatedSubsidySection: SubsidySection): Observable<SubsidySection>
  {
    return this.put(projectId, this.subsidyUrl, updatedSubsidySection);
  }

  public deleteSubsidySection(projectId: Guid): Observable<SubsidySection> {
    return this.delete(projectId, this.subsidyUrl);
  }
}
